import { render, staticRenderFns } from "./DpForm2.vue?vue&type=template&id=30bd23b8&scoped=true&"
import script from "./DpForm2.js?vue&type=script&lang=js&"
export * from "./DpForm2.js?vue&type=script&lang=js&"
import style0 from "./DpForm2.vue?vue&type=style&index=0&id=30bd23b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bd23b8",
  null
  
)

export default component.exports
import QForm from 'quasar/src/components/form/QForm.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QForm,QDialog,QCard,QCardSection,QAvatar,QCardActions,QBtn,QCircularProgress});qInstall(component, 'directives', {ClosePopup});
